import {
  GET_BEHAVIOR_DATA,
  GET_BEHAVIOR_DATA_SUCCESS,
  GET_BEHAVIOR_DATA_ERROR,
  GET_DIMENSIONS,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_ERROR,
  GET_DIMENSIONS_INDICATORS,
  GET_DIMENSIONS_INDICATORS_SUCCESS,
  GET_DIMENSIONS_INDICATORS_ERROR,
  GET_DIMENSIONS_PERIODS_MONTHS,
  GET_DIMENSIONS_PERIODS_MONTHS_SUCCESS,
  GET_DIMENSIONS_PERIODS_MONTHS_ERROR,
  GET_AVERAGE_BEHAVIOR_DATA,
  GET_AVERAGE_BEHAVIOR_DATA_SUCCESS,
  GET_AVERAGE_BEHAVIOR_DATA_ERROR,
  GET_PERIODS_YEARS,
  GET_PERIODS_YEARS_SUCCESS,
  GET_PERIODS_YEARS_ERROR,
  GENERATE_BEHAVIOR_INDICATORS_PDF,
  GENERATE_BEHAVIOR_INDICATORS_PDF_SUCCESS,
  GENERATE_BEHAVIOR_INDICATORS_PDF_ERROR,
  GET_BEHAVIOR_MEASUREMENTS_INDICATORS,
  GET_BEHAVIOR_MEASUREMENTS_INDICATORS_SUCCESS,
  GET_BEHAVIOR_MEASUREMENTS_INDICATORS_ERROR
} from './BehaviorSection.actions'
import {
  DEFAULT_MONTHS_OPTIONS,
  DEFAULT_YEARS_OPTIONS,
  DEFAULT_DIMENTIONS_OPTIONS
} from '../../config/settings/constant'

const initialState = {
  loading: false,
  error: null,
  updatedAt: null,
  averageScore: null,
  averageBehaviorIndicator: null,
  averageBehaviorIndicatorLoading: false,
  averageBehaviorIndicatorError: null,
  averageBehaviorYear: null,
  averageBehaviorMonth: null,
  dimensions: {},
  participation: {},
  indicators: null,
  dimensionsOptions: DEFAULT_DIMENTIONS_OPTIONS,
  dimensionsOptionsLoading: false,
  dimensionsOptionsError: null,
  monthsOptions: DEFAULT_MONTHS_OPTIONS,
  monthsOptionsLoading: false,
  monthsOptionsError: null,
  monthsByYear: {},
  monthsLoadingYear: null,
  yearsOptions: DEFAULT_YEARS_OPTIONS,
  yearsOptionsLoading: false,
  yearsOptionsError: null,
  dimensionsIndicators: [],
  dimensionsIndicatorsLoading: false,
  dimensionsIndicatorsError: null,
  generateBehaviorIndicatorsPdfLoading: false,
  generateBehaviorIndicatorsPdfError: null,
  measurementsIndicators: [],
  measurementsIndicatorsLoading: false,
  measurementsIndicatorsError: null,
  measurementsUpdatedAt: null
}

const behaviorSectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BEHAVIOR_DATA:
      return { ...state, loading: true }

    case GET_BEHAVIOR_DATA_SUCCESS:
      return {
        ...state,
        loading: null,
        dimensions: payload.dimensions,
        averageScore: payload.averageScore
      }

    case GET_BEHAVIOR_DATA_ERROR:
      return { ...state, loading: false, error: payload.error, averageScore: null, dimensions: null }

    case GET_DIMENSIONS:
      return { ...state, dimensionsOptionsLoading: true }

    case GET_DIMENSIONS_SUCCESS:
      return { ...state, dimensionsOptionsLoading: false, dimensionsOptions: payload }

    case GET_DIMENSIONS_ERROR:
      return { ...state, dimensionsOptionsLoading: false, dimensionsOptionsError: payload.error }

    case GET_DIMENSIONS_INDICATORS:
      return { ...state, dimensionsIndicatorsLoading: true }

    case GET_DIMENSIONS_INDICATORS_SUCCESS:
      return { ...state, dimensionsIndicatorsLoading: false, dimensionsIndicators: payload }

    case GET_DIMENSIONS_INDICATORS_ERROR:
      return { ...state, dimensionsIndicatorsLoading: false, dimensionsIndicatorsError: payload.error }

    case GET_DIMENSIONS_PERIODS_MONTHS:
      return {
        ...state,
        monthsOptionsLoading: true,
        monthsLoadingYear: payload?.year ?? null
      }

    case GET_DIMENSIONS_PERIODS_MONTHS_SUCCESS:
      return {
        ...state,
        monthsOptionsLoading: false,
        monthsLoadingYear: null,
        monthsByYear: {
          ...state.monthsByYear,
          ...(payload?.year != null && { [payload.year]: payload.months })
        },
        monthsOptions: payload?.months ?? state.monthsOptions
      }

    case GET_DIMENSIONS_PERIODS_MONTHS_ERROR:
      return {
        ...state,
        monthsOptionsLoading: false,
        monthsLoadingYear: null,
        monthsOptionsError: payload.error
      }

    case GET_PERIODS_YEARS:
      return { ...state, yearsOptionsLoading: true }

    case GET_PERIODS_YEARS_SUCCESS:
      return { ...state, yearsOptionsLoading: false, yearsOptions: payload }

    case GET_PERIODS_YEARS_ERROR:
      return { ...state, yearsOptionsLoading: false, yearsOptionsError: payload.error }

    case GET_AVERAGE_BEHAVIOR_DATA:
      return {
        ...state,
        averageBehaviorIndicatorLoading: true,
        averageBehaviorIndicatorError: null,
        updatedAt: null
      }

    case GET_AVERAGE_BEHAVIOR_DATA_SUCCESS:
      return {
        ...state,
        averageBehaviorIndicatorLoading: false,
        averageBehaviorIndicator: payload.average,
        averageBehaviorYear: payload.year || null,
        averageBehaviorMonth: payload.month || null,
        averageBehaviorIndicatorError: null,
        updatedAt: `22-${payload.month}-${payload.year}`
      }

    case GET_AVERAGE_BEHAVIOR_DATA_ERROR:
      return {
        ...state,
        averageBehaviorIndicatorLoading: false,
        averageBehaviorIndicatorError: payload.error,
        dimensionsError: payload.error,
        averageBehaviorIndicator: null,
        averageBehaviorYear: payload.year || null,
        averageBehaviorMonth: payload.month || null,
        updatedAt: null
      }

    case GENERATE_BEHAVIOR_INDICATORS_PDF:
      return { ...state, generateBehaviorIndicatorsPdfLoading: true, generateBehaviorIndicatorsPdfError: null }

    case GENERATE_BEHAVIOR_INDICATORS_PDF_SUCCESS:
      return { ...state, generateBehaviorIndicatorsPdfLoading: false, generateBehaviorIndicatorsPdf: payload }

    case GENERATE_BEHAVIOR_INDICATORS_PDF_ERROR:
      return {
        ...state,
        generateBehaviorIndicatorsPdfLoading: false,
        generateBehaviorIndicatorsPdfError: payload.error
      }

    case GET_BEHAVIOR_MEASUREMENTS_INDICATORS:
      return {
        ...state,
        measurementsIndicatorsLoading: true,
        measurementsIndicatorsError: null,
        indicators: null,
        measurementsUpdatedAt: null
      }

    case GET_BEHAVIOR_MEASUREMENTS_INDICATORS_SUCCESS:
      return {
        ...state,
        measurementsIndicatorsLoading: false,
        measurementsIndicators: payload.data,
        indicators: payload.indicators,
        measurementsIndicatorsError: null,
        measurementsUpdatedAt: payload.measurementsUpdatedAt
      }

    case GET_BEHAVIOR_MEASUREMENTS_INDICATORS_ERROR:
      return {
        ...state,
        measurementsIndicatorsLoading: false,
        measurementsIndicatorsError: payload.error,
        indicators: null,
        measurementsUpdatedAt: null
      }

    default:
      return state
  }
}

export default behaviorSectionReducer
